import { render, staticRenderFns } from "./ProductsTab.vue?vue&type=template&id=69a5157c&"
import script from "./ProductsTab.vue?vue&type=script&lang=ts&"
export * from "./ProductsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('69a5157c', component.options)
    } else {
      api.reload('69a5157c', component.options)
    }
    module.hot.accept("./ProductsTab.vue?vue&type=template&id=69a5157c&", function () {
      api.rerender('69a5157c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Atenciones/tabs/ProductsTab.vue"
export default component.exports